//style

import Interface from "./Interface";

const style = {

    getDirection(el) {
        var dir;
        if (el.currentStyle)
            dir = el.currentStyle['direction'];
        else if (window.getComputedStyle)
            dir = getComputedStyle(el, null).getPropertyValue('direction');
        return dir;
    },

    removeClass:function(el,className) {
        const list = className.split(' ');
        if(list.length>0){
            for (let i = 0; i < list.length; i++) {
                let c=list[i];
                if(!Interface.isEmptyString(c)){
                    el.classList.remove(c);
                }
            }
        }
    },

    addClass(el,className) {
        const list = className.split(' ');
        if(list.length>0){
            for (let i = 0; i < list.length; i++) {
                let c=list[i];
                if(!Interface.isEmptyString(c)){
                    el.classList.add(c);
                }
            }
        }
    },

    toggleClass(el,className) {
        const list = className.split(' ');
        if(list.length>0){
            for (let i = 0; i < list.length; i++) {
                if(el.classList.contains(list[i])){
                    el.classList.remove(list[i])
                }else{
                    el.classList.add(list[i]);
                }
            }
        }
    },
}

export default style

